<div class="content">
    <h4>{{'meli.taskprocessor.title'|translateTA}}</h4>
    <div class="text-content">
        <textarea nz-input [(ngModel)]="texto"> </textarea>
    </div>
    <div class="pb-content">
        <nz-progress [nzPercent]="value" [nzShowInfo]="false" nzStatus="active"></nz-progress>
    </div>
    <div class="button-content">
        <div class="spacer"></div>
        <span><button nz-button nzType="primary" (click)="sair()" [disabled]="disabled">{{'meli.form.exit'|translateTA}}</button></span>
    </div>
</div>
